import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { IUserPendingActivation } from '../../../types/users';
import Strings from '../../../i18n';
import { useDeleteUsersPendingActivationMutation } from '../../../services/users/usersService';
import { SideBarDeleteActionWithPopup } from '../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';

interface IActivateMultipleUsersSidebarProps {
  selectedItems: IUserPendingActivation[];
  setOpenRightSideBar: (open: boolean) => void;
  reloadTable: () => void;
}

export const ActivateMultipleUsersSidebar = ({
  selectedItems,
  setOpenRightSideBar,
  reloadTable
}: IActivateMultipleUsersSidebarProps) => {
  const [openSideBar, setOpenSideBar] = useState(false);
  const [
    deleteUsersPendingActivation,
    { isSuccess: isDeleteSuccess, isLoading: isDeleteLoading }
  ] = useDeleteUsersPendingActivationMutation();

  const deleteUsers = () => {
    deleteUsersPendingActivation(selectedItems.map((item) => item.id));
  };

  useEffect(() => {
    if (isDeleteSuccess) {
      toast.success(Strings.users.usersDeletedSuccessfully);
      setOpenRightSideBar(false);
      reloadTable();
    }
  }, [isDeleteSuccess]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.users.pendingUsers}</StyledTitleSideBar>
      </StyledContainerItems>
      <SideBarDeleteActionWithPopup
        onDelete={() => deleteUsers()}
        titleConfirmation={Strings.users.deleteUsersTitle}
        textConfirmation={Strings.common.thisActionIsIrreversible}
        textIcon={
          isDeleteLoading ? Strings.common.loading : Strings.users.deleteUsers
        }
      />
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
